package com.findyourbuddies.website.data.legal

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.client.request.get
import io.ktor.serialization.kotlinx.json.*
import kotlinx.serialization.json.Json

class LegalApi(
    private val client: HttpClient,
) {

    companion object {
        const val BASE_URL = "https://test.findyourbuddies.com"
    }

    suspend fun getPrivacyPolicyMarkdown(): String {
        return client
            .get("$BASE_URL/legal/privacy-policy")
            .body<LegalDocumentDto>()
            .content
    }

    suspend fun getTermsAndConditionsMarkdown(): String {
        return client
            .get("$BASE_URL/legal/terms-of-service")
            .body<LegalDocumentDto>()
            .content
    }
}

object ApiClient {
    val httpClient = HttpClient {
        install(ContentNegotiation) {
            json(
                Json {
                    ignoreUnknownKeys = true
                }
            )
        }
    }
}
